import { useTranslation } from 'react-i18next';
import { SortableListItem } from '@/components/listItem/SortableListItem';
import { getTranslationColumns } from '@/utils/translations';

export const SortableItem = ({
  id,
  toggleColumn,
  isLocked,
}: {
  id: string;
  toggleColumn: (columnKey: string) => void;
  isLocked?: boolean;
}) => {
  const { t } = useTranslation(['table', 'events', 'metrics']);
  const { translationKey, translationNs } = getTranslationColumns(id);
  const label = t(translationKey, { ns: translationNs, defaultValue: id });

  return (
    <SortableListItem
      id={id}
      testId={`${id}-sortable-item`}
      onRemove={isLocked ? undefined : () => toggleColumn(id)}
      ariaLabel={label}
      isSortable={!isLocked}
      isLocked={isLocked}
    >
      <span className="flex-1 truncate" title={label}>
        {label}
      </span>
    </SortableListItem>
  );
};
